import { render, staticRenderFns } from "./VerifyingYourEmailLayout.vue?vue&type=template&id=83f71c48&scoped=true&"
import script from "./VerifyingYourEmailLayout.vue?vue&type=script&lang=js&"
export * from "./VerifyingYourEmailLayout.vue?vue&type=script&lang=js&"
import style0 from "./VerifyingYourEmailLayout.vue?vue&type=style&index=0&id=83f71c48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f71c48",
  null
  
)

export default component.exports